export const getMaxCharactersMessage = (limit: number) =>
  `Must be less than ${limit} characters`
